module.exports = __webpack_public_path__ + "img/banner3_1_vi.30ab84f4.png";